export default __webpack_public_path__ + "static/media/photo-1549351236-caca0f174515.d2fd8a6e.jpeg";